export enum LiveCodeValidationResult {
  Valid,
  Invalid,
  AlreadyInUse,
}
